import {Injectable} from '@angular/core';
import {User} from '../../models/User';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BASE_URL} from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  currentApiUrl = '/user/userinfo';
  
  allUsers: User[];
  
  constructor(private http: HttpClient) {
    this.allUsers = [];
  }
  
  //
  getUsers(): Observable<any> {
    return this.http.get(BASE_URL + this.currentApiUrl);
  }
  
  whenUsersReady(): User[] {
    if (this.allUsers.length === 0) {
      this.getUsers().subscribe(users => {
        users.forEach(user => {
          this.allUsers.push(new User(user));
        });
        return this.allUsers;
      });
    } else {
      return this.allUsers;
    }
  }
}
